module.exports = __webpack_public_path__ + "img/antes_despues_32.a342aa0c.png";